"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeThumbnailCss = void 0;
const getChapterHeaderCss_1 = require("./getChapterHeaderCss");
/**
 * Styles for the theme thumbnails
 */
const getThemeThumbnailCss = (theme, prefix) => {
    const { properties: styleProps } = theme;
    const thumbnailChapterHeaderCss = (0, getChapterHeaderCss_1.getChapterHeaderCss)(theme, false, true, prefix);
    const thumbnailChapterBodyCss = `
    .thumbnail-body, .${theme === null || theme === void 0 ? void 0 : theme._id} p{
      text-indent: ${styleProps.paragraph.indent ? styleProps.hangingIndent : 0}cm;
      margin-block-end: ${!styleProps.paragraph.indent ? styleProps.paragraph.paragraphSpacing : 0}em;
    }

    .thumbnail-body, .${theme === null || theme === void 0 ? void 0 : theme._id} p:first-of-type{
      text-indent: 0rem !important;
    }
  `;
    return `${thumbnailChapterHeaderCss} ${thumbnailChapterBodyCss}`;
};
exports.getThemeThumbnailCss = getThemeThumbnailCss;
